import { RangeSlider, Text } from '@mantine/core';
import { useFilterFormContext } from '@/pages/Statistics/StatisticsPage';
import { generateMarks } from './GenerateMarks';

interface WorkedHoursSliderProps {
  monthly: boolean;
}

const FormWorkedHoursSlider = ({ monthly }: WorkedHoursSliderProps) => {
  const form = useFilterFormContext();
  const workedHoursSettings = {
    min: 0,
    max: monthly ? 200 : 2250,
    step: monthly ? 10 : 50,
    marks: generateMarks(0, monthly ? 200 : 2250, monthly ? 10 : 50, 5),
  };

  return (
    <>
      <Text size="sm" className="font-medium">
        Odpracované hodiny
      </Text>
      <RangeSlider
        mx={10}
        mb={24}
        label={value => `${value}h`}
        min={workedHoursSettings.min}
        max={workedHoursSettings.max}
        step={workedHoursSettings.step}
        marks={workedHoursSettings.marks}
        onChange={([from, to]) =>
          form.setValues({
            ...form.values,
            workedHoursFrom: from,
            workedHoursTo: to,
          })
        }
        value={[
          form.values.workedHoursFrom ?? workedHoursSettings.min,
          form.values.workedHoursTo ?? workedHoursSettings.max,
        ]}
      />
    </>
  );
};

export default FormWorkedHoursSlider;
